import { useMutation } from "@tanstack/react-query";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";

interface PresignedUrlResponse {
  url: string;
  filepath: string;
}

function useGetPresignedUrl() {
  const { authState } = useOktaAuth();

  return useMutation({
    mutationKey: ["getPresignedUrl"],
    mutationFn: (fileName: string) => {
      return axiosInstance.get<PresignedUrlResponse>(
        `v1/pre-signed-url/documents/${encodeURIComponent(fileName)}`,
        {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        }
      );
    },
  });
}

export default useGetPresignedUrl;
